module.exports = __webpack_public_path__ + "img/excel.5a46d794.svg";